const LINKEDIN_CONTENT_SEARCH_BASE = "https://www.linkedin.com/search/results/content/";

/**
 * Builds a LinkedIn content-search URL for the composed Boolean query, or
 * returns null when the query is empty (so the "Preview on LinkedIn" link can
 * be rendered disabled).
 */
export function buildLinkedinContentSearchUrl(query: string): string | null {
	const trimmed = query.trim();

	if (!trimmed) {
		return null;
	}

	return `${LINKEDIN_CONTENT_SEARCH_BASE}?keywords=${encodeURIComponent(trimmed)}&origin=FACETED_SEARCH&sortBy=%5B"date_posted"%5D`;
}
